import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaRegClock, FaRoad, FaCog, FaQuestionCircle, FaInfoCircle } from 'react-icons/fa';
import { RiLogoutBoxRFill, RiDashboardFill } from 'react-icons/ri';
import { TbHierarchy3 } from "react-icons/tb";
import SidebarItem from './SidebarItem';
import SidebarFooter from './SidebarFooter';
import Skeleton from 'react-loading-skeleton';
import './Sidebar.css';
import AuthContext from '../../contexts/AuthContext';
import AuthService from '../../services/AuthService';
const logoText = require('../../assets/images/logo_text_sm.png');

const Sidebar = ({ onToggle }) => {
    const [show, setShow] = useState(false);

    const auth = useContext(AuthContext);
    const location = useLocation();

    const handleToggleBtnClick = () => {
        setShow(!show);
        if (onToggle) {
            onToggle(!show);
        }
    };

    // Function to close sidebar on mobile when clicking a link/button
    const handleCloseSidebar = () => {
        if (window.innerWidth < 768) {
            setShow(false);
            if (onToggle) {
                onToggle(false);
            }
        }
    };

    //const handleLogout = async () => {
    //    try {
    //        // Clear client-side session and user data
    //        AuthService.removeUserSession();
    //        auth.setUser(null);
    //        window.location.href = '/login';

    //        // Send logout request to the server
    //        await fetch('/api/auth/logout', {
    //            method: 'GET',
    //            credentials: 'include', // Ensure cookies are sent with the request
    //        });
    //    } catch (error) {
    //        console.error('Error logging out:', error);
    //    }
    //};

    const getRecentTopics = async () => {
        const recentCount = 3;

        // Step 1: Get the user's topic history
        const topicHistory = auth.user.topicHistory;

        // Step 2: Sort topicHistory by visitedAt in descending order (most recent first)
        const sortedHistory = topicHistory.sort(
            (a, b) => new Date(b.visitedAt) - new Date(a.visitedAt)
        );

        // Step 3: Slice the top N topics (e.g., 3 most recent topics)
        const recentTopics = sortedHistory.slice(0, recentCount);

        // Step 4: Extract topic IDs for API request
        const topicIds = recentTopics.map((history) => history.topicId);

        // Step 5: Fetch topic details
        const response = await fetch('/api/topic/getTopics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ topicIds })
        });

        if (response.ok) {
            const res = await response.json();

            // Step 6: Sort res.data based on visitedAt in descending order
            const sortedTopicData = res.data.sort((a, b) => {
                const historyA = topicHistory.find((history) => history.topicId === a.topicId);
                const historyB = topicHistory.find((history) => history.topicId === b.topicId);

                return new Date(historyB.visitedAt) - new Date(historyA.visitedAt);
            });

            // Step 7: Update the state with sorted data
            setsideBarTopicData(sortedTopicData);
        }
    };

    const [sideBarTopicData, setsideBarTopicData] = useState(null);

    useEffect(() => {
        if (auth.user) {
            getRecentTopics();
        }
    }, [auth.user?.topicHistory]);

    const getFollowedPath = async (selectedProgress) => {
        var followedPaths = auth.user.followedPath;

        if (followedPaths.length === 0) {
            setPathData([]);
        }

        const start = 0;
        const end = 3;

        followedPaths = followedPaths.slice(start, end);
        const pathIds = followedPaths.map(topic => topic.pathId);

        const response = await fetch('/api/path/getPaths', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pathIds: pathIds })
        });

        if (response.ok) {
            const res = await response.json();
            setPathData(res.data);
        }
    };

    const getFollowedTopic = async (selectedProgress) => {
        var followedTopics = auth.user.followedTopic;

        if (followedTopics.length === 0) {
            setTopicData([]);
        }

        const start = 0;
        const end = 3;

        followedTopics = followedTopics.slice(start, end);
        const topicIds = followedTopics.map(topic => topic.topicId);

        const response = await fetch('/api/topic/getTopics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ topicIds: topicIds })
        });

        if (response.ok) {
            const res = await response.json();
            setTopicData(res.data);
        }
    };

    const [pathData, setPathData] = useState(null);

    useEffect(() => {
        if (auth.user) {
            getFollowedPath();
        }
    }, [auth.user?.followedPath]);

    const [topicData, setTopicData] = useState(null);

    useEffect(() => {
        if (auth.user) {
            getFollowedTopic();
        }
    }, [auth.user?.followedTopic]);
    
    return (
        <div>
                <button className="toggle-btn" onClick={handleToggleBtnClick}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            <div className={`sidebar ${show ? 'show' : ''} ${show ? '' : 'collapsed'}`}>
                <Link onClick={handleCloseSidebar}
                    to={
                    auth.user
                        ? `/home${auth.user.mostRecentGraph.nodeId
                            ? `?node=${auth.user.mostRecentGraph.nodeId}`
                            : auth.user.mostRecentGraph.pathId
                                ? `?path=${auth.user.mostRecentGraph.pathId}`
                                : ''
                        }`
                        : '/'
                }>
                    <img className="logoText" src={logoText} alt="logo" />
                </Link>
                <hr />
                <div className="sidebar-content">
                    <Link onClick={handleCloseSidebar}
                        to={
                        auth.user
                            ? `/home${auth.user.mostRecentGraph.nodeId
                                ? `?node=${auth.user.mostRecentGraph.nodeId}`
                                : auth.user.mostRecentGraph.pathId
                                    ? `?path=${auth.user.mostRecentGraph.pathId}`
                                    : ''
                            }`
                            : '/'
                    }>
                        <SidebarItem
                            icon={FaHome}
                            text="Home"
                            additionalClassNames={
                                (auth.user && location.pathname === '/home') ||
                                    (!auth.user && location.pathname === '/')
                                    ? 'active'
                                    : ''
                            }
                        />
                    </Link>

                    {auth.user ? (
                        <>
                            <Link to={`/dashboard/${auth.user.userProfileId}`} onClick={handleCloseSidebar}>
                                <SidebarItem icon={RiDashboardFill} text="Dashboard" additionalClassNames={location.pathname.startsWith('/dashboard') ? 'active' : ''} />
                            </Link>
                            <hr />
                            <Link to='/recent' onClick={handleCloseSidebar}>
                                <SidebarItem icon={FaRegClock} text="Recent Topics" additionalClassNames={location.pathname === '/recent' ? 'active' : ''} />
                            </Link>
                            {show && (
                                <div className="sidebar-subsection">
                                    {sideBarTopicData
                                        ? sideBarTopicData.map((topic, index) => (
                                            <Link key={index} to={`/topic/${topic.topicId}`} onClick={handleCloseSidebar}>
                                                <SidebarItem text={topic.name} additionalClassNames='' />
                                            </Link>
                                        ))
                                        : <Skeleton count={1} width={200} />
                                    }
                                </div>
                            )}
                            <hr />
                            <Link to='/path' onClick={handleCloseSidebar}>
                                <SidebarItem icon={FaRoad} text="Followed Path" additionalClassNames={location.pathname === '/path' ? 'active' : ''} />
                            </Link>
                            <div className="sidebar-subsection">
                                {pathData
                                    ? pathData.map((path, index) => (
                                        <Link key={index} to={`/home?path=${path.pathId}`} onClick={handleCloseSidebar}>
                                            <SidebarItem text={path.pathName} additionalClassNames='' />
                                        </Link>
                                    ))
                                    : <Skeleton count={1} width={200} />
                                }
                            </div>
                            <hr />
                            <Link to='/followedTopic' onClick={handleCloseSidebar}>
                                <SidebarItem icon={TbHierarchy3} text="Followed Topic" additionalClassNames={location.pathname === '/followedTopic' ? 'active' : ''} />
                            </Link>
                            <div className="sidebar-subsection">
                                {topicData
                                    ? topicData.map((topic, index) => (
                                        <Link key={index} to={`/home?node=${topic.topicId}`} onClick={handleCloseSidebar}>
                                            <SidebarItem text={topic.name} additionalClassNames='' />
                                        </Link>
                                    ))
                                    : <Skeleton count={1} width={200} />
                                }
                            </div>
                        </>
                    ) : null}

                    <hr />
                    {/*<Link to='/help'>*/}
                    {/*    <SidebarItem icon={FaQuestionCircle} text="Help" additionalClassNames={location.pathname === '/help' ? 'active' : ''} />*/}
                    {/*</Link>*/}

                    {/*<Link to='/about'>*/}
                    {/*    <SidebarItem*/}
                    {/*        icon={FaInfoCircle}*/}
                    {/*        text="About"*/}
                    {/*        additionalClassNames={location.pathname === '/about' ? 'active' : ''}*/}
                    {/*    />*/}
                    {/*</Link>*/}

                    {auth.user ? (
                        <Link to='/settings/account' onClick={handleCloseSidebar}>
                            <SidebarItem icon={FaCog} text="Settings" additionalClassNames={location.pathname.startsWith('/settings') ? 'active' : ''} />
                        </Link>
                    ) : null}

                    {/*{auth.user ? (*/}
                    {/*    <Link to='/login'>*/}
                    {/*        <SidebarItem icon={RiLogoutBoxRFill} onClick={handleLogout} text="Logout" />*/}
                    {/*    </Link>*/}
                    {/*) : null}*/}
                </div>

                {!show && <div className="sidebar-footer" />}
                {show && <SidebarFooter />}
            </div>
        </div>
    );
};

export default Sidebar;